import {makeGet} from '@yandex-delivery/utils'

import type {FormOrderVertical} from '../types'

export const verticalGetter = makeGet<FormOrderVertical>()
